(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-bet-buttons/assets/javascripts/coupon-bet-buttons.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-bet-buttons/assets/javascripts/coupon-bet-buttons.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch,
  shallowEqual = _ReactRedux.shallowEqual;
const _React = React,
  useState = _React.useState;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectEventSelections = _svs$components$tipse.selectEventSelections,
  selectEventUserSelections = _svs$components$tipse.selectEventUserSelections,
  selectSystemType = _svs$components$tipse.selectSystemType,
  selectMSign = _svs$components$tipse.selectMSign,
  selectEventUSign = _svs$components$tipse.selectEventUSign,
  selectRSystem = _svs$components$tipse.selectRSystem,
  selectUSystem = _svs$components$tipse.selectUSystem;
const _svs$components$tipse2 = svs.components.tipsen.engine.actions,
  toggleAlternative = _svs$components$tipse2.toggleAlternative,
  toggleMSign = _svs$components$tipse2.toggleMSign;
const _svs$components$tipse3 = svs.components.tipsen.engine.constants.systems,
  SYSTEM_RSYS = _svs$components$tipse3.SYSTEM_RSYS,
  SYSTEM_USYS = _svs$components$tipse3.SYSTEM_USYS;
const selectIsKeyLoading = svs.components.tipsen.loadingState.selectors.selectIsKeyLoading;
const LoadingKeys = svs.components.tipsen.loadingState.constants.LoadingKeys;
const getOutcomeAriaLabel1X2 = svs.components.poolBetting.ariaUtils.getOutcomeAriaLabel1X2;
const CouponBetButtons = _ref => {
  let awayParticipant = _ref.awayParticipant,
    couponId = _ref.couponId,
    board = _ref.board,
    event = _ref.event,
    homeParticipant = _ref.homeParticipant,
    outcomeLabels = _ref.outcomeLabels,
    outcomes = _ref.outcomes,
    hasDisabledBets = _ref.hasDisabledBets,
    eventTypeId = _ref.eventTypeId,
    isSvenskaFolketAsOutcomesEnabled = _ref.isSvenskaFolketAsOutcomesEnabled;
  const selections = useSelector(state => selectEventSelections(state, couponId, board, event)) || [];
  const userSelections = useSelector(state => selectEventUserSelections(state, couponId, board, event)) || [];
  const uSign = useSelector(state => selectEventUSign(state, couponId, board, event));
  const rSystem = useSelector(state => selectRSystem(state, couponId));
  const uSystem = useSelector(state => selectUSystem(state, couponId));
  const dispatch = useDispatch();
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const hasMSigns = [SYSTEM_RSYS, SYSTEM_USYS].includes(systemType) && (rSystem || uSystem);
  const mSign = useSelector(state => selectMSign(state, couponId, board, event), shallowEqual);
  const isLoadingPix = useSelector(state => selectIsKeyLoading(state, LoadingKeys.PIX));
  const _useState = useState(uSign),
    _useState2 = _slicedToArray(_useState, 2),
    uSignIndex = _useState2[0],
    setUSignIndex = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedUSignIndex = _useState4[0],
    setFocusedUSignIndex = _useState4[1];
  const mSignClassNames = ['coupon-bet-buttons-checkbox-label', 'qa-coupon-bet-button'];
  if (mSign.value) {
    mSignClassNames.push('coupon-bet-buttons-user-selected');
  }
  return React.createElement(React.Fragment, null, hasMSigns && React.createElement("div", {
    className: "pg_bet_buttons__m_sign"
  }, React.createElement("label", {
    className: mSignClassNames.join(' '),
    "data-testid": "".concat(board, "_").concat(event, "_M"),
    onClick: e => e.stopPropagation()
  }, React.createElement("input", {
    "aria-checked": mSign.value,
    "aria-label": "matematisk gardering",
    checked: mSign.value,
    disabled: mSign.disabled || hasDisabledBets || isLoadingPix,
    name: "".concat(board, "_").concat(event),
    onChange: () => {
      dispatch(toggleMSign({
        board,
        couponId,
        event,
        systemType,
        uSignIndex
      }));
      setUSignIndex(uSign);
    },
    type: "checkbox"
  }), "MG")), React.createElement("div", {
    className: "coupon-bet-buttons"
  }, selections.map((selection, index) => {
    const userSelected = userSelections[index];
    const label = outcomeLabels[index] ? outcomeLabels[index].ariaLabel || outcomeLabels[index].text : undefined;
    const classNames = ['coupon-bet-buttons-checkbox-label', 'qa-coupon-bet-button'];
    if (selection && userSelected) {
      classNames.push('coupon-bet-buttons-user-selected');
    } else if (selection) {
      classNames.push('coupon-bet-buttons-pix-selected');
    }
    if (hasDisabledBets || isLoadingPix) {
      classNames.push('coupon-bet-buttons-checkbox-label--disabled');
    }
    const isUSign = uSign === index && systemType === SYSTEM_USYS;
    if (isUSign) {
      classNames.push('coupon-bet-buttons-checkbox-label--u-sign');
      if (focusedUSignIndex === index) {
        classNames.push('coupon-bet-buttons-checkbox-label--u-sign-focused');
      }
    }
    const ariaLabel = getOutcomeAriaLabel1X2({
      awayParticipant,
      eventTypeId,
      homeParticipant,
      svenskaFolketValue: isSvenskaFolketAsOutcomesEnabled ? outcomes[index] : undefined,
      sign: outcomeLabels[index].text
    });
    const ariaLabelSuffix = isUSign ? ', Utgångstecken' : '';
    const key = "".concat(board, "_").concat(event, "_").concat(index);
    return React.createElement("label", {
      className: classNames.join(' '),
      "data-testid": "".concat(board, "_").concat(event, "_").concat(index),
      key: key,
      onClick: e => e.stopPropagation()
    }, React.createElement("input", {
      "aria-checked": selection,
      "aria-label": "".concat(ariaLabel).concat(ariaLabelSuffix),
      checked: selection,
      disabled: hasDisabledBets || isLoadingPix,
      name: "".concat(board, "_").concat(event),
      onChange: () => {
        dispatch(toggleAlternative({
          boardIndex: board,
          couponId,
          event,
          outcome: index,
          systemType
        }));
      },
      type: "checkbox"
    }), outcomes[index] || label);
  })), systemType === SYSTEM_USYS && React.createElement("div", {
    className: "pg_bet_buttons__u_sign sr-only"
  }, selections.map((selection, index) => {
    const label = outcomeLabels[index] ? outcomeLabels[index].ariaLabel || outcomeLabels[index].text : undefined;
    const key = "".concat(board, "_").concat(event, "_").concat(index);
    const disabled = hasDisabledBets || isLoadingPix || !selection || uSign === null;
    return React.createElement("label", {
      key: key,
      onClick: e => e.stopPropagation()
    }, React.createElement("input", {
      "aria-label": "Utg\xE5ngstecken ".concat(outcomeLabels[index].ariaLabel),
      checked: uSign === index,
      disabled: disabled,
      name: "uSign-".concat(couponId, "-").concat(board, "-").concat(event),
      onBlur: () => setFocusedUSignIndex(null),
      onChange: () => {
        dispatch(toggleAlternative({
          boardIndex: board,
          couponId,
          event,
          outcome: index,
          systemType
        }));
      },
      onFocus: () => setFocusedUSignIndex(index),
      type: "radio"
    }), outcomes[index] || label);
  })));
};
setGlobal('svs.components.tipsen.couponBetButtons.CouponBetButtons', CouponBetButtons);

 })(window);